import React from "react";
import './navbar.css';
//import logo from '../logo.svg'
import { NavLink } from "react-router-dom";

const NavBar = () => {
  return(
    <nav className="navbar navbar-expand-lg navbar-light bg-transparent">
      <NavLink className="navbar-brand" to="/"><img src={require('../logoo.png')} alt=""/></NavLink>
      <button className="navbar-toggler" 
              type="button" 
              data-toggle="collapse" 
              data-target="#navbarNav" 
              aria-controls="navbarNav" 
              aria-expanded="false" 
              aria-label="Toggle navigation">
        <span className="navbar-toggler-icon"></span>
      </button>
      
      <div className="collapse navbar-collapse justify-content-end" id="navbarNav">
        <ul className="navbar-nav">

          <li className="nav-item pr-2">
            <NavLink className="nav-link" to="/explore">EXPLORE</NavLink>
          </li>
          <li className="nav-item pr-2">
            <NavLink className="nav-link" to="/cycle">CYCLE</NavLink>
          </li>
          <li className="nav-item  pr-2">
            <NavLink className="nav-link" to="/climb">CLIMB</NavLink>
          </li>
          <li className="nav-item  pr-2">
            <NavLink className="nav-link" to="/our_team">OUR TEAM</NavLink>
          </li>
          <li className="nav-item  pr-2">
            <NavLink className="nav-link" to="/request_info">REQUEST INFO</NavLink>
          </li>
        </ul>
      </div>
    </nav>
    /*<div>
      <NavLink to="/">Home</NavLink>
      <NavLink to="/explore">Explore</NavLink>
      <NavLink to="/climb">Climb</NavLink>
    </div>*/
    /*<li className="nav-item active">
      <a className="nav-link"><NavLink className="nav-link" to="/">Home<span className="sr-only">(current)</span></NavLink></a>
    </li>*/
  );
};

export default NavBar;


// WEBPACK FOOTER //
// ./src/components/navbar.jsx